/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import orderClasses from "../../orders/orders.module.css";
import reportClasses from "../reports.module.css";
import PaymentReportTable from "./paymentReportTable";
import Input from "../../../../component/inputpm";
import Loader from "../../../../component/loader";
import IconButton from "@mui/material/IconButton";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import moment from "moment";
import Paper from "@mui/material/Paper";
import Breadcrumb from "../../../../component/breadcrumb";
import { SearchIcon, ClearIcon } from "../../../../component/icons/icons";
import { Grid } from "@mui/material";

// Manage order page class
class PaymentReport extends Component {
  // Declare property values that belongs to the component
  state = {
    paymentList: [],
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalPaymentCount: 0,
    sortBy: "createdStamp",
    sortOrder: "DESC",
    customerName: "",
    clientName: "",
    amount: "",
    status: "",
    paidBy: "",
    orderId: "",
    from: "",
    to: "",

    today: moment(new Date()).format("yyyy-MM-DD"),
    bread: [
      { title: "Reports", url: "/paymentReport" },
      { title: "Payments Report", url: "/paymentReport" },
    ],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    this.getPaymentReport();
  }

  convertDateParam(date) {
    return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  }

  convertTillDateParam(date) {
    return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
  }

  // Fetch orders list
  getPaymentReport = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    var jsonData = {
      customerName: this.state.customerName,
      clientName: this.state.clientName,
      amount: this.state.amount,
      orderId: this.state.orderId,
      from: this.state.from
        ? encodeURIComponent(this.convertDateParam(this.state.from))
        : "",
      to: this.state.to
        ? encodeURIComponent(this.convertTillDateParam(this.state.to))
        : "",
    };

    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/reports?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&reportType=PAYMENT_REPORT&jsonData=${JSON.stringify(jsonData)}`,
      {},
      pageOptions,
    )
      .then((res) => {
        //let data = JSON.parse(res);
        this.setState({
          paymentList: res.data.paymentReport.orderPaymentDetailList,
          totalPaymentCount: +res.headers["x-total-count"],
          loading: false,
        });
      })
      .catch((e) => {
        if (e.response) {
          this.props.setErrorMessage(e.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({ loading: false });
      });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getPaymentReport();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getPaymentReport();
      },
    );
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getPaymentReport();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getPaymentReport();
        },
      );
    }
  };

  // Update state data on input change
  onChange = (e) => {
    if (e.target.name === "from") {
      this.setState({
        to: "",
      });
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Search/Filter orders
  filterTable = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        page: 1,
        startRecord: 1,
        // customerBan: '',
        // customerName: '',
        // featureCode: '',
        // settlementId: '',
        // itemDescription: '',
      },
      () => {
        this.getPaymentReport();
      },
    );
  };

  // Clear all search filters
  clearFilters = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        customerName: "",
        clientName: "",
        amount: "",
        status: "",
        paidBy: "",
        orderId: "",
        from: "",
        to: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getPaymentReport();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterTable();
    }
  };

  classes = { ...orderClasses, ...reportClasses };

  // Render order view
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <Paper className="tablePaper" elevation={0}>
            {/* Search filters start */}
            <div
              className={this.classes.searchOuterDiv}
              style={{ marginBottom: "5px" }}
            >
              {/* <div>
                            <Select
                            native
                            name={'facilityId'}
                            variant={'outlined'}
                            size={'small'}
                            label={t('Warehouse')}
                            value={this.state.facilityId}
                            onChange={(e) => { this.onChange(e) }}
                            onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                        >
                            <option value=""></option>
                            {this.state.warehouseList.map((opt, key) => (
                                <option key={key} value={opt.id}>{opt.name}</option>
                            ))}
                        </Select>

                        </div> */}
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("ORDER_ID")}
                  value={this.state.orderId}
                  name={"orderId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.ordInputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("CUSTOMER_NAME")}
                  value={this.state.customerName}
                  name={"customerName"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("OWNER")}
                  value={this.state.clientName}
                  name={"clientName"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("AMOUNT")}
                  value={this.state.amount}
                  name={"amount"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <TextField
                  name="from"
                  id="date"
                  type="date"
                  // style={{ width: '170px' }}
                  value={this.state.from}
                  label={t("FROM_DATE")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant={"outlined"}
                  size={"small"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  inputProps={{ max: this.state.today }}
                />
              </div>

              <div>
                <TextField
                  name="to"
                  id="date"
                  type="date"
                  // style={{ width: '170px' }}
                  value={this.state.to}
                  label={t("TO_DATE")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant={"outlined"}
                  size={"small"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  inputProps={{ min: this.state.from, max: this.state.today }}
                />
              </div>

              {/* <div className={this.classes.searchOrderLabelOuter} style={{ paddingRight: 0 }}>
                                <div className={this.classes.searchOrderLabelInner} style={{ paddingRight: 0 }}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.filterTable}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearFilters}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
            </div>
            {/* Search filters end */}

            {/* Order table component */}
            <PaymentReportTable
              list={this.state.paymentList}
              rowsPerPage={this.state.rowsPerPage}
              totalPaymentCount={this.state.totalPaymentCount}
              page={this.state.page}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              updateSorting={this.updateSorting}
              providerType={this.props.providerType}
            />
          </Paper>
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(PaymentReport));
